import Button from '@atlaskit/button/new';
import { token } from '@atlaskit/tokens';
import { Dimensions, Font } from 'components/visuals';
import { styled } from 'styled-components';

export const StyledTextLabel = styled.p<{ width?: string; textalign?: string }>`
  color: ${token('color.text.subtle', '#44546F')};
  font-family: ${Font.displayFamily};
  width: ${(props) => (props.width ? props.width : `${Dimensions.units(3)}%`)};
  text-align: ${(props) => (props.textalign ? props.textalign : `end`)};
`;

export const StyledTextValueWrapper = styled.div`
  width: ${Dimensions.units(8.25)}%;
  text-align: start;
  overflow-wrap: anywhere;
`;

export const StyledButtonsWrapper = styled.div`
  width: ${Dimensions.units(9)}%;
`;

export const StyledPipeSymbol = styled.span`
  color: ${token('color.text.subtle', '#44546F')};
  padding-left: ${Dimensions.units(0.5)}px;
  padding-right: ${Dimensions.units(0.5)}px;
`;

export const StyledLink = styled.a`
  color: ${token('color.icon.information', '#1D7AFC')};
  padding: ${Dimensions.units(0.5)}px ${Dimensions.units(0.5)}px ${Dimensions.units(0.5)}px 0;
  cursor: pointer;
`;

export const StyledActionsButtonLink = styled.button`
  padding: 0;
  margin: 0;
  font-weight: inherit;
  font-size: inherit;
  font-family: inherit;
  line-height: inherit;
  color: ${token('color.link', '#0C66E4')};
  background: none;
  border: none;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
  &:disabled {
    color: ${token('color.text.disabled', '#8590A2')};
    cursor: not-allowed;
  }
`;

export const FieldWrapper = styled.div<{ width?: string }>`
  margin-right: ${Dimensions.units(2)}px;
  width: ${(props) => (props.width ? props.width : '')};
`;

export const AddContactWrapper = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: end;
  margin-bottom: ${Dimensions.units(2)}px;
`;

export const StyledFlex = styled.div<{
  width?: string;
  flexDirection?: boolean;
  $marginBottom?: string;
}>`
  display: flex;
  flex-direction: ${(props) => (props.flexDirection ? 'column' : 'row')};
  gap: ${Dimensions.units(1)}px;
  padding: ${Dimensions.units(0.5)}px;
  width: ${(props) => (props.width ? props.width : '')};
  margin-bottom: ${(props) => (props.$marginBottom ? props.$marginBottom : '')};
`;

export const StyledContactsHeading = styled.div`
  color: ${token('color.text.subtle', '#44546F')};
  font-family: ${Font.displayFamily};
  text-align: start;
`;

export const ContactsWrapper = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  width: ${Dimensions.units(12.5)}%;
`;

export const StyledDivWithBorder = styled.div`
  margin-top: ${Dimensions.units(3)}px;
  border-bottom: 1px solid ${token('color.text.subtle', '#44546F')};
`;

export const StyledSpan = styled.span<{ margin?: string; $padding?: string; boldValue?: boolean }>`
  margin: ${(props) => (props.margin ? props.margin : '')};
  padding: ${(props) => (props.$padding ? props.$padding : '')};
  ${({ boldValue }) => boldValue && 'font-weight: 600;'}
  display: inline-block;
`;

export const StyledSenInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const StyledTableData = styled.td<{ $paddingLeft?: boolean }>`
  padding: ${({ $paddingLeft }) =>
    $paddingLeft
      ? `${Dimensions.units(1.5)}px !important`
      : `${Dimensions.units(1.5)}px ${Dimensions.units(1.5)}px ${Dimensions.units(
          1.5,
        )}px 0 !important`};

  font-size: ${Dimensions.units(1.75)}px;
`;

export const StyledTDSection = styled.div<{ width?: string }>`
  display: flex;
  flex-direction: column;
  gap: ${Dimensions.units(0.5)}px;
  width: ${(props) => (props.width ? props.width : '')};
`;

export const StyledHistoryWrapper = styled.div<{ dispalyParterName?: boolean }>`
  width: ${Dimensions.units(40)}px;
  display: grid;
  grid-template-columns: ${(props) => (props.dispalyParterName ? ' 1fr 1fr 1fr' : ' 1fr 1fr')};
  grid-row-gap: ${Dimensions.units(1.5)}px;
  align-items: baseline;
  background-color: ${token('color.background.information', '#E9F2FF')};
  padding: ${Dimensions.units(0.5)}px;
  overflow: scroll;
`;

export const StyledHistoryTableWrapper = styled.div`
  width: 95%;
  align-items: baseline;
  background-color: ${token('color.background.information', '#E9F2FF')};
  margin-top: ${Dimensions.units(1)}px;
  padding: 0 ${Dimensions.units(3)}px ${Dimensions.units(1.5)}px ${Dimensions.units(3)}px;
`;

export const StyledMigratedHistoryWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledMigratedHistoryTableData = styled.td`
  padding-left: ${Dimensions.units(1)}px;
  padding-right: ${Dimensions.units(1)}px;
`;

export const StyledParagraph = styled.p<{ margin?: string; padding?: string }>`
  margin: ${(props) => (props.margin ? props.margin : '')};
  padding: ${(props) => (props.padding ? props.padding : '')};
`;

export const StyledLabel = styled.span`
  padding: ${Dimensions.units(0.25)}px ${Dimensions.units(0.5)}px;
  text-transform: uppercase;
  background: ${token('color.background.neutral.subtle', '#F7F8F9')};
  display: inline-block;
  margin-left: ${Dimensions.units(1)}px;
  border: 1px solid ${token('color.border', '#B3B9C4')};
  border-radius: ${Dimensions.units(0.5)}px;
  color: ${token('color.icon', '#44546F')};
  font-weight: 700;
`;

export const StyledModalFieldsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${Dimensions.units(3)}px;
`;

export const StyledModalInputWrapper = styled.div`
  width: ${Dimensions.units(7.5)}%;
`;

export const StyledModalHeaderWithBorder = styled.div`
  border-bottom: 1px solid ${token('color.text.subtle', '#44546F')};
  padding: 0;
`;

export const ContactWrapper = styled.div<{
  width?: string;
  $textAlign?: string;
  $padding?: string;
}>`
  width: ${(props) => (props.width ? props.width : '')};
  text-align: ${(props) => (props.$textAlign ? props.$textAlign : '')};
  padding: ${(props) => (props.$padding ? props.$padding : '')};
  word-wrap: anywhere;
`;

export const StyledModalWrapper = styled.div`
  padding: 24px 0 0 0;
`;

export const StyledSectionMessageWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const StyledNewTrialOfferWrapper = styled.div`
  padding: ${Dimensions.units(3.5)}px 0 0 ${Dimensions.units(5)}px;
`;

export const StyledFlexWrapper = styled.div`
  display: flex;
`;

export const StyledFlexColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  > * + * {
    margin-top: ${Dimensions.units(2)}px;
  }
`;

export const TextAreaWrapper = styled.div`
  width: ${Dimensions.units(28.75)}px;
`;

export const StyledLoadingButton = styled(Button)`
  width: 18% !important;
`;
